export default {
  methods: {
    strip_html(value) {
      if (value === null || value === undefined) return '';
      return String(value).replace(/<[^>]+>/g, '');
    },

    sanitized_section_descriptions(section) {
      if (!section) return [];
      const entries = Array.isArray(section.descriptions) ? section.descriptions : [];
      const forbidden = [/^page\s+\d+(\s+of\s+\d+)?$/i];
      return entries
        .map((e) => this.strip_html(e))
        .map((t) => (t || '').replace(/\s+/g, ' ').trim())
        .filter((line) => line && !forbidden.some((p) => p.test(line)));
    },

    split_job_title(raw_title = '') {
      const safe = (raw_title || '').trim();
      if (!safe) return { primary: 'Job Profile', secondary: '' };
      const parts = safe.split(':');
      if (parts.length === 1) return { primary: safe, secondary: '' };
      const primary = parts.shift().trim();
      const secondary = parts.join(':').trim();
      return { primary: primary || safe, secondary };
    },

    parse_key_value(line = '') {
      if (typeof line !== 'string') return null;
      const segments = line.split(':');
      if (segments.length < 2) return null;
      const label = segments.shift().trim();
      const value = segments.join(':').trim();
      if (!label || !value || label.length > 60) return null;
      return { label, value };
    },

    safe_key(label = '') {
      return String(label || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    },

    sanitize_text(value) {
      if (value === null || value === undefined) return null;
      const trimmed = String(value).trim();
      return trimmed ? trimmed : null;
    },

    is_generic_extraction_title(title = '') {
      const safe = String(title || '').trim().toLowerCase();
      const generic_patterns = [
        'extracted document',
        'extracted text',
        'untitled',
        'job description',
        'document',
      ];
      return generic_patterns.some(pattern => safe.includes(pattern));
    },
  },
};
